var map = {
	"./gif/cellarmaster-demo.gif": "927e",
	"./gif/fencify-demo.gif": "2dc5",
	"./gif/passman-demo.gif": "359c",
	"./gif/photo-sharing-demo.gif": "8f45",
	"./gif/portfolio-demo.gif": "5ed6",
	"./gif/rosewood-demo.gif": "6d13",
	"./gif/shoppies-demo.gif": "46d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";